"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hastNodeToUtf8Markup = void 0;
var util_1 = require("./util");
var encodeUtf8Text = function (text) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};
var encodeUtf8AttributeValue = function (text) { return text.replace(/"/g, '&quot;'); };
var hastPropertiesToUtf8Attributes = function (properties, tagName, config) {
    if (!properties) {
        return [];
    }
    return Object.keys(properties).reduce(function (attributes, name) {
        var serialized = config.serializeAttribute(tagName, name, properties[name]);
        if (!serialized)
            return attributes;
        if (typeof serialized === 'string') {
            return __spreadArrays(attributes, [serialized]);
        }
        var attributeName = serialized[0], value = serialized[1];
        return __spreadArrays(attributes, [attributeName + "=\"" + encodeUtf8AttributeValue(value) + "\""]);
    }, []);
};
var hastElementNodeToUtf8Markup = function (node, config) {
    var _a;
    var tagName = config.serializeTagName(node.tagName);
    if (!tagName)
        return '';
    var attributes = hastPropertiesToUtf8Attributes(node.properties, node.tagName, config);
    if (config.serializeAsSelfClosing(node)) {
        return "<" + __spreadArrays([tagName], attributes).join(' ') + "/>";
    }
    return ("<" + __spreadArrays([tagName], attributes).join(' ') + ">" +
        ((_a = node.children) !== null && _a !== void 0 ? _a : []).map(function (child) { return exports.hastNodeToUtf8Markup(child, config); }).join('') +
        ("</" + tagName + ">"));
};
exports.hastNodeToUtf8Markup = function (node, config) {
    if (util_1.isText(node)) {
        return encodeUtf8Text(node.value);
    }
    if (config.isFragment(node)) {
        if (node.children) {
            return node.children.map(function (child) { return exports.hastNodeToUtf8Markup(child, config); }).join('');
        }
        return '';
    }
    return hastElementNodeToUtf8Markup(node, config);
};
